import { MaterialCommunityIcons } from "@expo/vector-icons";
import React from "react";
import { View } from "react-native";

import { radius } from "@/lib/theme";

// ---------------------------------------------------------------------------
// Category icon configurations
// ---------------------------------------------------------------------------

interface IconConfig {
    bg: string;
    iconColor: string;
    iconName: React.ComponentProps<typeof MaterialCommunityIcons>["name"];
}

const CATEGORY_ICONS: Record<string, IconConfig> = {
    "Personal Care": {
        bg: "rgba(69,210,176,0.12)",
        iconColor: "#14957D",
        iconName: "account"
    },
    Toileting: {
        bg: "rgba(100,116,231,0.12)",
        iconColor: "#6474E7",
        iconName: "water"
    },
    Nutrition: {
        bg: "rgba(245,158,66,0.12)",
        iconColor: "#D97706",
        iconName: "silverware-fork-knife"
    },
    Activities: {
        bg: "rgba(16,185,129,0.12)",
        iconColor: "#059669",
        iconName: "walk"
    },
    Treatment: {
        bg: "rgba(239,68,68,0.12)",
        iconColor: "#DC2626",
        iconName: "medical-bag"
    },
    Household: {
        bg: "rgba(168,85,247,0.12)",
        iconColor: "#7C3AED",
        iconName: "home"
    }
};

// ---------------------------------------------------------------------------
// Individual icon components
// ---------------------------------------------------------------------------

function CategoryIcon({ config }: { config: IconConfig }) {
    return (
        <View
            style={{
                width: 32,
                height: 32,
                borderRadius: radius.sm,
                backgroundColor: config.bg,
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            <MaterialCommunityIcons name={config.iconName} size={18} color={config.iconColor} />
        </View>
    );
}

export function PersonalCareIcon() {
    return <CategoryIcon config={CATEGORY_ICONS["Personal Care"]} />;
}

export function ToiletingIcon() {
    return <CategoryIcon config={CATEGORY_ICONS["Toileting"]} />;
}

export function NutritionIcon() {
    return <CategoryIcon config={CATEGORY_ICONS["Nutrition"]} />;
}

export function ActivitiesIcon() {
    return <CategoryIcon config={CATEGORY_ICONS["Activities"]} />;
}

export function TreatmentIcon() {
    return <CategoryIcon config={CATEGORY_ICONS["Treatment"]} />;
}

export function HouseholdIcon() {
    return <CategoryIcon config={CATEGORY_ICONS["Household"]} />;
}

// ---------------------------------------------------------------------------
// Lookup function
// ---------------------------------------------------------------------------

export function getCategoryIcon(category: string): React.ReactElement {
    const config = CATEGORY_ICONS[category];
    if (!config) {
        // Fallback icon for unknown categories
        return (
            <View
                style={{
                    width: 32,
                    height: 32,
                    borderRadius: radius.sm,
                    backgroundColor: "rgba(139,137,168,0.12)",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <MaterialCommunityIcons name="help-circle-outline" size={18} color="#8B89A8" />
            </View>
        );
    }
    return <CategoryIcon config={config} />;
}
